import { Component } from '@angular/core';
import { LogoComponent } from "../../../../shared/components/logo/logo.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { PrimaryButtonComponent } from "../../../../shared/components/primary-button/primary-button.component";
import { Router } from '@angular/router';

@Component({
  selector: 'app-welcome-dialog',
  standalone: true,
  imports: [LogoComponent, TranslocoPipe, PrimaryButtonComponent],
  templateUrl: './welcome-dialog.component.html',
  styleUrl: './welcome-dialog.component.css'
})
export class WelcomeDialogComponent {
  constructor(private router: Router) { }

  modalDialogId: string = 'dashboard_modal_welcome';

  openModal(): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.showModal();
    }
  }

  closeModal(): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.close();
    }

    this.router.navigate(['/settings/plans']);
  }
}
